import { render, staticRenderFns } from "./advertisements.vue?vue&type=template&id=b10c9e98&scoped=true&"
import script from "./advertisements.vue?vue&type=script&lang=js&"
export * from "./advertisements.vue?vue&type=script&lang=js&"
import style0 from "./advertisements.vue?vue&type=style&index=0&id=b10c9e98&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10c9e98",
  null
  
)

export default component.exports